module.exports = __webpack_public_path__ + "img/Dokan.3aeda859.png";